import { z } from 'zod';
import { zDateOnly, zId, zOptId, zOptText, zText, zTime } from './common';

export const roomSchema = z.object({
  campusId: zId,
  name: zText(80),
  capacity: z.number().int().min(1).max(100000).nullable().optional(),
  description: zOptText(1000),
  approvalGroupId: zOptId,
  isActive: z.boolean().default(true),
});

export const resourceSchema = z.object({
  campusId: zOptId,
  name: zText(80),
  kind: z.enum(['equipment', 'vehicle', 'other']).default('equipment'),
  quantity: z.number().int().min(1).max(10000).default(1),
  approvalGroupId: zOptId,
  isActive: z.boolean().default(true),
});

export const approvalGroupSchema = z.object({
  name: zText(80),
  campusId: zOptId,
  memberPersonIds: z.array(zId).max(100).default([]),
});

export const recurrenceSchema = z
  .object({
    freq: z.enum(['daily', 'weekly', 'monthly']),
    interval: z.number().int().min(1).max(12).default(1),
    byWeekday: z.array(z.number().int().min(0).max(6)).max(7).default([]),
    untilDate: zDateOnly.nullable().optional(),
    count: z.number().int().min(1).max(500).nullable().optional(),
  })
  .refine((r) => r.untilDate || r.count, { message: 'Indica una fecha final o un número de repeticiones' });

export const calendarEventSchema = z
  .object({
    name: zText(160),
    description: zOptText(5000),
    campusId: zOptId,
    location: zOptText(200),
    startDate: zDateOnly,
    startTime: zTime.nullable().optional(),
    endDate: zDateOnly,
    endTime: zTime.nullable().optional(),
    allDay: z.boolean().default(false),
    recurrence: recurrenceSchema.nullable().optional(),
    isPublic: z.boolean().default(false),
    bookings: z
      .array(
        z
          .object({ roomId: zOptId, resourceId: zOptId, quantity: z.number().int().min(1).max(10000).default(1) })
          .refine((b) => !!b.roomId !== !!b.resourceId, { message: 'Elige una sala o un recurso' }),
      )
      .max(50)
      .default([]),
  })
  .refine((e) => e.allDay || (e.startTime && e.endTime), {
    message: 'Indica hora de inicio y fin',
    path: ['startTime'],
  })
  .refine(
    (e) =>
      e.endDate > e.startDate ||
      (e.endDate === e.startDate && (e.allDay || (e.startTime && e.endTime && e.endTime > e.startTime))),
    { message: 'El fin debe ser posterior al inicio', path: ['endDate'] },
  );

export const bookingDecisionSchema = z.object({
  status: z.enum(['approved', 'rejected']),
  note: zOptText(500),
});

export const calendarRangeSchema = z.object({
  from: zDateOnly,
  to: zDateOnly,
  campusId: zId.optional(),
  roomId: zId.optional(),
});
